<div class="container">
  <mat-dialog-content class="dialog-container">
    <div mat-dialog-title class="dialog-header">
      <span i18n="@@ViewAllRegionsDialogTitle">Regions for</span> "{{
        trademarkName
      }}"
    </div>
    <button mat-dialog-close class="material-icons close-icon" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
    <ul class="regions-list">
      @for (region of regions; track region) {
      <li>{{ region.label }}</li>
      }
    </ul>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      class="cdx-but-md"
      color="primary"
      mat-stroked-button
      mat-dialog-close
      i18n="@@ViewAllRegionsDialogBackButton"
    >
      Back
    </button>
  </mat-dialog-actions>
</div>
